import axios from "./axiosInstance";
import {
  FeePaymentApiResponse,
  FeePaymentsApiResponse,
  FeePaymentCreatePayload,
  FeePaymentSearchParams
} from "../types/feePaymentTypes";

/**
 * Create a new fee payment
 */
export const createFeePayment = async (payload: FeePaymentCreatePayload): Promise<FeePaymentApiResponse> => {
  const response = await axios.post<FeePaymentApiResponse>("/fee-payments", payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

/**
 * Search fee payments with optional parameters
 */
export const getFeePayments = async (params: FeePaymentSearchParams): Promise<FeePaymentsApiResponse> => {
  const response = await axios.get<FeePaymentsApiResponse>("/fee-payments", { params: { ...params, page: 1, limit: 10000 } });
  return response.data;
};

/**
 * Fetch a specific fee payment by ID
 */
export const getFeePaymentById = async (feePaymentId: string): Promise<FeePaymentApiResponse> => {
  const response = await axios.get<FeePaymentApiResponse>(`/fee-payments/${feePaymentId}`);
  return response.data;
};

/**
 * Update an existing fee payment
 */
export const updateFeePayment = async (feePaymentId: string, payload: Partial<FeePaymentCreatePayload>): Promise<FeePaymentApiResponse> => {
  const response = await axios.put<FeePaymentApiResponse>(`/fee-payments/${feePaymentId}`, payload);
  return response.data;
};

/**
 * Delete a fee payment
 */
export const deleteFeePayment = async (feePaymentId: string): Promise<FeePaymentApiResponse> => {
  const response = await axios.delete<FeePaymentApiResponse>(`/fee-payments/${feePaymentId}`);
  return response.data;
};
